<template>
  <div class="brand">
    <!-- Hero -->
    <section class="hero">
      <div class="hero-content">
        <h1>品牌故事</h1>
        <p>用心守护每一份人宠情谊</p>
      </div>
    </section>

    <!-- 品牌理念 -->
    <section class="philosophy">
      <div class="container">
        <div class="philosophy-content">
          <div class="philosophy-text">
            <h2>我们的理念</h2>
            <p class="lead">每一只宠物都是独一无二的星辰，在属于它们的星系中闪耀。</p>
            <p>宠物星系致力于为宠物主提供一个记录、分享和纪念宠物生活的平台。我们相信，爱不会因为离别而消失，它会以另一种方式永远存在。</p>
          </div>
          <div class="philosophy-values">
            <div class="value-item">
              <span class="value-icon">💫</span>
              <div>
                <h4>永恒纪念</h4>
                <p>让每一份爱都有归属</p>
              </div>
            </div>
            <div class="value-item">
              <span class="value-icon">🤝</span>
              <div>
                <h4>温暖陪伴</h4>
                <p>陪伴度过艰难时刻</p>
              </div>
            </div>
            <div class="value-item">
              <span class="value-icon">💚</span>
              <div>
                <h4>用心服务</h4>
                <p>专业贴心的服务体验</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 品牌故事 -->
    <section class="story">
      <div class="container">
        <div class="story-content">
          <div class="story-timeline">
            <div class="timeline-item">
              <div class="timeline-year">2023</div>
              <div class="timeline-text">
                <h4>品牌创立</h4>
                <p>宠物星系正式成立，致力于为宠物主提供专业的纪念服务</p>
              </div>
            </div>
            <div class="timeline-item">
              <div class="timeline-year">2024</div>
              <div class="timeline-text">
                <h4>服务升级</h4>
                <p>纪念馆服务全面升级，服务超过10,000位宠物主</p>
              </div>
            </div>
          </div>
          <div class="story-text">
            <h2>我们的故事</h2>
            <p>宠物星系诞生于对生命的敬畏与对爱的珍视。创始人曾经历过与爱宠离别的痛苦，深知那份思念需要被温柔对待。</p>
            <p>我们希望为每一位宠物主提供一个安放思念的空间，让回忆有处可栖，让爱不因离别而消散。</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 联系方式 -->
    <section id="contact" class="contact-section">
      <div class="container">
        <div class="contact-content">
          <h2>联系方式</h2>
          <p>如果您有任何问题或需求，请随时与我们联系，我们将竭诚为您服务。</p>

          <div class="info-list">
            <div class="info-item">
              <div class="info-icon">✉️</div>
              <div class="info-content">
                <h4>电子邮箱</h4>
                <p>1002561026@qq.com</p>
              </div>
            </div>
            <div class="info-item">
              <div class="info-icon">🕐</div>
              <div class="info-content">
                <h4>工作时间</h4>
                <p>周一至周五 9:00 - 18:00</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  name: 'Brand'
}
</script>

<style scoped>
.brand {
  padding-top: 70px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* Hero - 星空渐变 */
.hero {
  background: linear-gradient(135deg, #0f0c29 0%, #302b63 50%, #24243e 100%);
  padding: 120px 20px;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.hero::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background:
    radial-gradient(circle at 30% 70%, rgba(123, 104, 238, 0.15) 0%, transparent 50%),
    radial-gradient(circle at 70% 30%, rgba(230, 168, 215, 0.1) 0%, transparent 40%);
  pointer-events: none;
}

.hero-content {
  position: relative;
  z-index: 1;
}

.hero-logo {
  width: 120px;
  height: 120px;
  object-fit: contain;
  margin-bottom: 20px;
  border-radius: 50%;
  box-shadow: 0 0 40px rgba(123, 104, 238, 0.5);
}

.hero h1 {
  font-size: 3rem;
  color: #fff;
  margin-bottom: 20px;
  font-weight: 700;
  text-shadow: 0 0 40px rgba(123, 104, 238, 0.5);
}

.hero p {
  font-size: 1.2rem;
  color: rgba(255, 255, 255, 0.85);
}

/* Philosophy */
.philosophy {
  padding: 100px 0;
  background: linear-gradient(180deg, #f8f7ff 0%, #ffffff 100%);
}

.philosophy-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 80px;
  align-items: center;
}

.philosophy-text h2 {
  font-size: 2.2rem;
  color: #302b63;
  margin-bottom: 30px;
  font-weight: 600;
}

.philosophy-text .lead {
  font-size: 1.3rem;
  color: #7b68ee;
  line-height: 1.8;
  margin-bottom: 20px;
  font-weight: 500;
}

.philosophy-text p {
  color: #555;
  line-height: 1.8;
  font-size: 1.05rem;
}

.philosophy-values {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.value-item {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 25px 30px;
  background: #fff;
  border-radius: 16px;
  transition: all 0.3s ease;
  border: 1px solid rgba(123, 104, 238, 0.1);
  box-shadow: 0 4px 20px rgba(48, 43, 99, 0.05);
}

.value-item:hover {
  transform: translateX(10px);
  box-shadow: 0 10px 30px rgba(123, 104, 238, 0.15);
  border-color: rgba(123, 104, 238, 0.2);
}

.value-icon {
  font-size: 2.5rem;
}

.value-item h4 {
  font-size: 1.2rem;
  color: #302b63;
  margin-bottom: 5px;
}

.value-item p {
  color: #777;
  font-size: 0.95rem;
}

/* Story */
.story {
  padding: 100px 0;
  background: linear-gradient(180deg, #f0edff 0%, #f8f7ff 100%);
}

.story-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 80px;
  align-items: center;
}

.story-timeline {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

.timeline-item {
  display: flex;
  gap: 30px;
  align-items: flex-start;
}

.timeline-year {
  font-size: 2rem;
  font-weight: 700;
  color: #7b68ee;
  min-width: 80px;
  text-shadow: 0 0 20px rgba(123, 104, 238, 0.3);
}

.timeline-text h4 {
  font-size: 1.2rem;
  color: #302b63;
  margin-bottom: 8px;
}

.timeline-text p {
  color: #666;
  line-height: 1.6;
}

.story-text h2 {
  font-size: 2.2rem;
  color: #302b63;
  margin-bottom: 30px;
  font-weight: 600;
}

.story-text p {
  color: #555;
  line-height: 1.8;
  margin-bottom: 20px;
  font-size: 1.05rem;
}

/* 联系方式 */
.contact-section {
  padding: 80px 0;
  background: linear-gradient(180deg, #f8f7ff 0%, #ffffff 100%);
}

.contact-content {
  max-width: 600px;
  margin: 0 auto;
  text-align: center;
}

.contact-content h2 {
  font-size: 2rem;
  color: #302b63;
  margin-bottom: 20px;
}

.contact-content > p {
  color: #666;
  line-height: 1.8;
  margin-bottom: 40px;
}

.info-list {
  display: flex;
  justify-content: center;
  gap: 60px;
  flex-wrap: wrap;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 15px;
}

.info-icon {
  font-size: 1.5rem;
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #7b68ee 0%, #9d7bff 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 4px 15px rgba(123, 104, 238, 0.3);
}

.info-content h4 {
  font-size: 1.1rem;
  color: #302b63;
  margin-bottom: 5px;
  text-align: left;
}

.info-content p {
  color: #666;
  text-align: left;
}

@media (max-width: 968px) {
  .philosophy-content,
  .story-content {
    grid-template-columns: 1fr;
    gap: 50px;
  }

  .story-timeline {
    order: 1;
  }
}

@media (max-width: 600px) {
  .hero h1 {
    font-size: 2.2rem;
  }

  .philosophy-text h2,
  .story-text h2,
  .section-title {
    font-size: 1.8rem;
  }

  .timeline-item {
    flex-direction: column;
    gap: 10px;
  }
}
</style>
